import Icon, { icons } from '../../../generic/Icon';

//  Green circle with a white checkmark in the middle.
const MarketingCheckmark = () => (
  <span className="fossa-auth__marketing__blurb__feature-list__checkmark">
    <Icon icon={icons.check} />
  </span>
);

/**
 * Displays the marketing "blurb" in a two-column Auth page.
 */
const MarketingBlurb = () => (
  <section className="fossa-auth__marketing__blurb">
    <h1 className="fossa-auth__marketing__blurb__heading">
      Start free and scale as you go
    </h1>
    <p className="fossa-auth__marketing__blurb__paragraph">
      Continuous compliance checks and vulnerability management to keep your code risk free.
    </p>
    <ul className="fossa-auth__marketing__blurb__feature-list">
      <li className="fossa-auth__marketing__blurb__feature-list__item">
        <MarketingCheckmark /> License Identification
      </li>
      <li className="fossa-auth__marketing__blurb__feature-list__item">
        <MarketingCheckmark /> Manage 5 Projects
      </li>
      <li className="fossa-auth__marketing__blurb__feature-list__item">
        <MarketingCheckmark /> Vulnerability Management
      </li>
      <li className="fossa-auth__marketing__blurb__feature-list__item">
        <MarketingCheckmark /> Basic Teams / Roles
      </li>
    </ul>
  </section>
);

export default MarketingBlurb;
